module.exports = __webpack_public_path__ + "static/media/expertise_techyoulove.7ddf4222.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/expertise_techyoulove.svg
// module id = 1400
// module chunks = 0